import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {RESOURCES as scheduleResources} from '../fuseReportsResourceMap';
import {addLeadingZero} from '../shared/functions';
import {isSysopOrSysadmin, hasSectionAccess} from '../shared/authFunctions';
import {getPostHeaders} from '../shared/serverFunctions';
import {commonStyles} from '../shared/styles';
import CircularProgress from 'material-ui/CircularProgress';
import IconButton from 'material-ui/IconButton';
import RaisedButton from 'material-ui/RaisedButton';
import ContentDownload from 'material-ui/svg-icons/file/file-download';
import ContentError from 'material-ui/svg-icons/alert/error-outline';

/**
 * A component to display a Generate Report button with an API call
 *
 */
class RenderReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: null,
            submitting: false,
            success: false
        };
    }

    // Modify the Date Range payload if relative
    assemblePayload = () => {
        const payload = JSON.parse(JSON.stringify(this.props.payload));
        // Create From and To dates for relative Reports
        if (payload.dateRange && payload.dateRange.daysBack > 0) {
            const to = new Date();
            const toDay = to.getFullYear() + '-' + addLeadingZero(to.getMonth() + 1) + '-' + addLeadingZero(to.getDate());
            const from = new Date();
            from.setDate(from.getDate() - payload.dateRange.daysBack);
            const fromDay = from.getFullYear() + '-' + addLeadingZero(from.getMonth() + 1) + '-' + addLeadingZero(from.getDate());

            // Set the Date Range from today to days back
            payload.dateRange.daysBack = 0;
            payload.dateRange.fromDay = fromDay;
            payload.dateRange.toDay = toDay;
        }
        this.postRenderReport(payload);
    };

    postRenderReport = (payload) => {
        this.setState({
            errorMessage: null,
            submitting: true
        }, () => {
            let errorMessage = null;
            const resource = scheduleResources.RenderReport.POST(payload);
            const headers = getPostHeaders();
            const fileName = this.props.filename;
            headers['Accept'] = 'application/pdf';
            axios({
                method: resource.method,
                url: resource.uri,
                data: resource.data,
                headers: headers,
                responseType: 'arraybuffer'
            }).then((result) => {
                if (result && result.data) {
                    const blob = new Blob([result.data], {type: 'application/pdf'});
                    // Directly download result as PDF
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = fileName + '.pdf';
                    link.target = '_blank';
                    link.title = fileName + '.pdf';
                    link.rel = 'noopener noreferrer';
                    document.body.appendChild(link);
                    link.click();
                    setTimeout(function () {
                        // Delay revoking ObjectURL (Firefox)
                        window.URL.revokeObjectURL(url);
                    }, 100);
                    link.remove();
                }
                this.setState({
                    errorMessage: errorMessage,
                    submitting: false
                });
            }).catch((error) => {
                if (error.response) {
                    // Server response outside 2xx
                    console.log(error.response.data);
                } else if (error.request) {
                    // No response
                    console.log(error.request);
                } else {
                    console.log('Render Report Error: ', error.message);
                }
                errorMessage = 'Sorry, there was an error generating this PDF.';
                this.setState({
                    errorMessage: errorMessage,
                    submitting: false
                });
            });
        });
    };

    render() {
        const {
            buttonType,
            label
        } = this.props;

        const {
            errorMessage,
            submitting
        } = this.state;

        if (!isSysopOrSysadmin()) {
            if (!hasSectionAccess('schedule_reports')) return null;
        }

        return (
            <Fragment>
                {buttonType === 'icon' &&
                    <span>
                        {!errorMessage &&
                        <IconButton
                            onClick={() => this.assemblePayload()}
                            disabled={!!(submitting)}
                            style={(submitting) ? commonStyles.hidden : {}}
                        >
                            <ContentDownload/>
                        </IconButton>
                        }
                        {errorMessage &&
                            <IconButton
                                onClick={() => this.assemblePayload()}
                                disabled={!!(submitting)}
                                style={(submitting) ? commonStyles.hidden : commonStyles.error}
                                iconStyle={commonStyles.error}
                            >
                                <ContentError/>
                            </IconButton>
                        }
                        {submitting &&
                            <CircularProgress
                                size={30}
                                thickness={2}
                                className="loader"
                                style={commonStyles.buttonInline}
                            />
                        }
                    </span>
                }
                {buttonType === 'text' &&
                    <div style={commonStyles.buttonContainerWithMessage}>
                        <div style={commonStyles.buttonContainer}>
                            {submitting &&
                                <CircularProgress
                                    size={32}
                                    thickness={2}
                                    className="loader"
                                    style={commonStyles.buttonInlineRight}
                                />
                            }
                            <RaisedButton
                                primary
                                type="button"
                                label={label}
                                disabled={!!(submitting)}
                                onClick={() => this.assemblePayload()}
                                style={commonStyles.buttonInlineRight}
                            />
                        </div>
                        <p className="error" style={commonStyles.buttonErrorMessage}>
                            {errorMessage &&
                                <span>Sorry, there was an error generating this PDF.</span>
                            }
                            {!errorMessage &&
                                <span>&nbsp;</span>
                            }
                        </p>
                    </div>
                }
            </Fragment>
        );
    }
}

RenderReport.propTypes = {
    buttonType: PropTypes.string,
    filename: PropTypes.string,
    label: PropTypes.string,
    payload: PropTypes.object
};

RenderReport.defaultProps = {
    buttonType: 'text',
    filename: 'Report',
    label: 'Generate PDF',
    payload: {
        dateRange: {
            daysBack: 0,
            fromDay: '',
            toDay: '',
            tz: ''
        },
        location: {
            cities: [],
            dbas: [],
            districts: [],
            locations: [],
            states: [],
        },
        mode: 'live',
        system: ''
    }
};

export default RenderReport;



// WEBPACK FOOTER //
// ./src/Fuse/components/RenderReport.js